import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          style: 'width:200px;min-width:200px;max-width:200px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'شماره پرسنلی',
          value: 'personelNumber',
          align: 'center',
          style: 'width:180px;min-width:180px;max-width:180px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'اعزام به بیمارستان',
          value: 'goToHospital',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'درمان در محل',
          value: 'place',
          align: 'center',
          style: 'width:180px;min-width:180px;max-width:180px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'خودداری واخذ امضا',
          value: 'refuse',
          align: 'center',
          style: 'width:200px;min-width:200px;max-width:20px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'لغو ماموریت',
          value: 'cancle',
          align: 'center',
          style: 'width:180px;min-width:180px;max-width:180px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'استقرار',
          value: 'deploye',
          align: 'center',
          style: 'width:160px;min-width:160px;max-width:160px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'تحویل به امبولانس دیگر',
          value: 'toOtherAmbulance',
          align: 'center',
          style: 'width:230px;min-width:230px;max-width:230px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'فوت',
          value: 'dead',
          align: 'center',
          style: 'width:140px;min-width:140px;max-width:140px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'تعداد کل مددجو',
          value: 'allPatient',
          align: 'center',
          style: 'width:180px;min-width:180px;max-width:180px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'تعداد ماموریت',
          value: 'allMission',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'شهری',
          value: 'city',
          align: 'center',
          style: 'width:160px;min-width:160px;max-width:160px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'جاده ای',
          value: 'road',
          align: 'center',
          style: 'width:160px;min-width:160px;max-width:160px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'کلان شهر',
          value: 'bigCity',
          align: 'center',
          style: 'width:160px;min-width:160px;max-width:160px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'ماموریت کاذب',
          value: 'fake',
          align: 'center',
          style: 'width:180px;min-width:180px;max-width:180px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'عدم همکاری از هر نوع اقدام درمانی',
          value: 'noCollaboration',
          align: 'center',
          style: 'width:270px;min-width:270px;max-width:270px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'عدم حضور مددجو',
          value: 'noPatient',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
      ],
      tableItems: [],
      recordFile: '',
      player: false,
      searchFromDate: '',
      searchToDate: '',
      searchCityId: null,
      searchUserId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let fullName = '';
        fullName += data[i].firstName ? data[i].firstName : '-';
        fullName += ' ';
        fullName += data[i].lastName ? data[i].lastName : '-';
        this.tableItems.push({
          fullName: fullName,
          personelNumber: data[i].personnelNumber ? data[i].personnelNumber : '-',
          goToHospital: data[i].transferToHospital ? data[i].transferToHospital : '-',
          place: data[i].initialTreatment ? data[i].initialTreatment : '-',
          refuse: data[i].noCollaborationWithSign ? data[i].noCollaborationWithSign : '-',
          cancle: data[i].canceled ? data[i].canceled : '-',
          deploye: data[i].deployment ? data[i].deployment : '-',
          dead: data[i].death ? data[i].death : '-',
          allPatient: data[i].patientsCount ? data[i].patientsCount : '-',
          allMission: data[i].missionsCount ? data[i].missionsCount : '-',
          city: data[i].withinCityCount ? data[i].withinCityCount : '-',
          road: data[i].outOfCityCount ? data[i].outOfCityCount : '-',
          bigCity: data[i].withMetropolisCount ? data[i].withMetropolisCount : '-',
          toOtherAmbulance: data[i].deliverToAnotherCode ? data[i].deliverToAnotherCode : '-',
          fake: data[i].fake ? data[i].fake : '-',
          noCollaboration: data[i].noCollaboration ? data[i].noCollaboration : '-',
          noPatient: data[i].noPatient ? data[i].noPatient : '-',
        });
      }
    },
    sortStatus: function (data) {
      if (data.sortState == 1) {
        data.sortState = 2;
      } else if (data.sortState == 2) {
        data.sortState = 1;
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCTechnicianPerformancePaginationReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchCityId = null;
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCTechnicianPerformancePaginationReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchCityId = null;
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    stopMusic: function () {
      var sound = this.$refs.audioFile;
      sound.pause();
      sound.currentTime = 0;
      this.player = false;
    },
  },
};
